import { Box, SxProps, Theme } from '@mui/material';

interface CustomTabPanelProps {
  value: string;
  selected: string;
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
}

const CustomTabPanel = ({
  value,
  selected,
  children,
  sx,
  ...other
}: CustomTabPanelProps) => {
  return (
    <div role="tabpanel" hidden={value !== selected} {...other}>
      {value === selected && <Box sx={sx || { p: 3 }}>{children}</Box>}
    </div>
  );
};

export default CustomTabPanel;
